<template>
  <div class="author-overview">
    <v-row v-if="author && author.id" dense>
      <!-- 1. CARTE AUTEUR (Pleine largeur) -->
      <v-col cols="12" md="6">
        <v-card outlined>
          <v-card-title class="text-subtitle-1 font-weight-bold py-2">
            {{ $t('Auteur') }}
          </v-card-title>
          <v-card-text class="text--primary pt-2">
            <v-row class="align-center" dense>
              <v-col cols="12" sm="8">
                <div class="d-flex mb-1">
                  <span class="font-weight me-2">{{ $t('Nom') }} : </span>
                  <span class="font-weight-bold me-2">{{ author.full_name }}</span>
                </div>
                <div class="d-flex mb-1">
                  <span class="font-weight me-2">{{ $t('Adresse') }} :</span>
                  <span class="font-weight-bold me-2">{{
                      (author.addresses || []).map(e => e.address).join('; ')
                    }}</span>
                </div>
                <div class="d-flex mb-1">
                  <span class="font-weight me-2">{{ $t('Emails') }} :</span>
                  <span class="font-weight-bold me-2">{{
                      author.email ? author.email.join(' / ') : '-'
                    }}</span>
                </div>
                <div
                  v-if="formatPhoneNumber(author).length > 3"
                  cols="12"
                  class="d-flex justify-start"
                >
                  <span class="font-weight me-2">{{ $t('Téléphones') }} :</span>
                  <div class="font-weight-bold me-2">
                    {{ formatPhoneNumber(author) }}
                  </div>
                </div>
                <div class="d-flex mb-1" v-if="author.compte_auteur">
                  <span class="font-weight me-2">{{ $t('Compte auteur') }} :</span>
                  <span class="font-weight-bold me-2">{{ author.compte_auteur }}</span>
                </div>
              </v-col>
              <v-col cols="12" md="3" sm="4" class="text-center">
                <v-avatar size="65" rounded>
                  <v-img :src="author.avatar || require(`@/assets/images/avatars/1.png`)" contain/>
                </v-avatar>
              </v-col>
              <v-col
                cols="12"
                class="d-flex "
              >
                <span class="shrink text-no-wrap">{{ $t('Complétion du profil') }} :</span>
                <div class="text--primary font-weight-semibold ml-2 d-flex align-center"
                     style="width: 200px">
                  <v-btn
                    v-if="$can('edit','Author')"
                    icon x-small :to="{name:'author-info',params:{id:author.id}}"
                    :color="getAuthorColor()">
                    <v-icon
                      size="16"
                      class="me-2"
                    >
                      {{ mdiFileDocumentEditOutline }}
                    </v-icon>
                  </v-btn>
                  <v-progress-linear
                    :value="author.progress || 0"
                    :color="getColor1()"
                    height="15"

                    rounded
                  >
                        <span class=" rounded px-1 py-0 body-2">{{
                            (author.progress || 0).toFixed(0)
                          }}%</span>
                  </v-progress-linear>
                </div>

              </v-col>
              <!-- BLOC PROFIL -->
              <v-col cols="9" class="mt-2">
                <v-card
                  outlined
                  class="pa-3 rounded-lg"
                  style="border-left: 4px solid var(--v-primary-base) !important;"
                >
                  <template v-if="author.author_profile || author.profile">
                    <!-- Entête avec Chip Profil -->
                    <div class="d-flex align-center text-subtitle-1 font-weight-bold mb-2">
                      <span class="text-caption font-weight-bold text--secondary mr-2">{{
                          $t('Type de profil')
                        }} :</span>
                      <span class="primary--text">{{
                          (author.author_profile || author.profile).profile
                        }}</span>
                    </div>

                    <v-divider class="my-2"/>

                    <!-- Caractéristique -->
                    <div class="d-flex align-start mb-2">
                      <v-icon small color="primary" class="mr-2 mt-1">
                        {{ mdiAccountCogOutline }}
                      </v-icon>
                      <div>
                        <div class="text-caption font-weight-bold text--secondary">
                          {{ $t('Caractéristique') }}
                        </div>
                        <div class="text-body-2 font-weight-medium text--primary">
                          {{
                            (author.author_profile || author.profile).caracteristic || (author.author_profile || author.profile).caracteristics || 'N/A'
                          }}
                        </div>
                      </div>
                    </div>

                    <!-- Niveau d'accompagnement -->
                    <div class="d-flex align-start">
                      <v-icon small color="primary" class="mr-2 mt-1">
                        {{ mdiBookAccountOutline }}
                      </v-icon>
                      <div>
                        <div class="text-caption font-weight-bold grey--text text--darken-1">
                          {{ $t("Niveau d'accompagnement") }}
                        </div>
                        <div class="text-body-2 font-weight-medium text--primary">
                          {{ (author.author_profile || author.profile).level_of_support || 'N/A' }}
                        </div>
                      </div>
                    </div>
                  </template>

                  <!-- État vide -->
                  <template v-else>
                    <div class="d-flex align-center text--secondary text-body-2">
                      <v-icon small class="mr-2" color="warning">
                        {{ mdiInformationSlabBoxOutline }}
                      </v-icon>
                      <span>{{ $t('Aucun profil attribué') }}</span>
                    </div>
                  </template>
                </v-card>
              </v-col>
              <!--              <div class="d-flex align-center mt-1" style="width: 100px">
                              <v-progress-linear
                                :value="author.progress || 0"
                                :color="getColor1()"
                                show-label
                                rounded
                                striped
                              >
                              </v-progress-linear>
                            </div>-->
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- 2. DÉTAILS & DERNIER CONTACT (2 Colonnes côte à côte) -->
      <v-col cols="12" md="3" sm="6">
        <v-card outlined class="fill-height">
          <v-card-title class="text-subtitle-1 font-weight-bold py-2">
            {{ $t('Détails') }}
          </v-card-title>
          <v-card-text class="text--primary">
            <div>{{ $t('Âge') }} : {{ author.age || '-' }} ans</div>
            <div>{{ $t('Type d’auteur') }} :
              {{ author.author_type ? author.author_type.label : '-' }}
            </div>
            <div>{{ $t('Infos particulières') }} :
              {{ author.author_state ? author.author_state.label : '-' }}
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" md="3" sm="6">
        <v-card outlined class="fill-height">
          <v-card-text class="text-center py-4">
            <v-avatar size="36" color="primary" class="mb-2">
              <v-icon color="white" small>{{ icons.mdiEmailSendOutline }}</v-icon>
            </v-avatar>
            <div class="text-h6 font-weight-bold">{{ formatDate(author.last_contacted_date) }}</div>
            <div class="text-caption">{{ $t('Dernier contact par mail') }}</div>
            <div class="text-caption primary--text font-weight-medium">
              {{ $t('Il y a') }} {{ author.last_contacted_ago }}
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- 3. TIMELINES ET ÉVÉNEMENTS (Passés en cols="12" sm="6" pour 2 blocs par ligne) -->
      <v-col cols="12" md="4" sm="6">
        <v-card outlined>
          <v-card-title class="text-subtitle-1 font-weight-bold py-2">
            {{ $t('Evénements réseaux sociaux') }}
          </v-card-title>
          <v-card-text style="max-height: 450px" class="overflow-y-auto">
            <p v-if="!(author.author_events || []).length">
              {{ $t('Aucun evénement lié à un réseau social renseigné') }}</p>
            <v-timeline
              dense
              class="timeline-custom-dense timeline-custom-dots"
            >
              <v-timeline-item
                v-for="(ev,index) in author.author_events"
                :key="ev.id"
                small
                :color="`${ev.network?ev.network.color:(index%2?'primary':'info')}`"
              >
                <div class="d-flex justify-space-between align-center flex-wrap">
                  <h4 class="font-weight-semibold me-1">
                    {{ ev.label }}
                  </h4>
                </div>
                <div>
                  <small v-if="ev.eventtype"
                         class="text-no-wrap font-weight-medium">{{ ev.eventtype.label }}</small>
                </div>

                <small class="text-no-wrap font-weight-medium">{{ formatDate(ev.date) }}</small>
                <p class="my-1 d-flex align-center " v-if="ev.network">
                  <v-avatar
                    rounded
                    size="30"
                    color="#5e566917"
                    class="me-1"
                  >
                    <v-img
                      contain
                      :src="ev.network.logo"
                      height="20"
                    ></v-img>
                  </v-avatar>
                  {{ ev.network.label }}
                </p>
                <v-btn outlined x-small :color="`${index%2?'primary':'info'}`" :href="ev.location"
                       target="_blank" class="mt-2" v-if="ev.location">
                  <v-icon
                    class="me-1"
                  >
                    {{ mdiLink }}
                  </v-icon>
                  <span class="">
                    {{ $t('Voir') }}
                  </span>
                </v-btn>
              </v-timeline-item>
            </v-timeline>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="4" sm="6">
        <v-card outlined>
          <v-card-title class="text-subtitle-1 font-weight-bold py-2">
            <span>{{ $t('Réseaux sociaux') }}</span>
          </v-card-title>

          <v-card-text style="max-height: 250px" class="overflow-y-auto">
            <p v-if="!(author.author_networks || []).length">{{
                $t('Aucun réseaux social renseigné')
              }}</p>
            <div
              v-for="(network,index) in author.author_networks"
              :key="network.id"
              :class="`d-flex align-center ${index >0 ? 'mt-2':''}`"
            >
              <a :href="network.link" target="_blank" rel="noopener">
                <v-avatar
                  rounded
                  size="38"
                  color="#5e566917"
                  class="me-4"
                >
                  <v-img
                    contain
                    :src="network.network.logo"
                    height="20"
                  ></v-img>
                </v-avatar>
              </a>
              <div class="d-flex align-center flex-grow-1 flex-wrap">
                <div>
                  <h4 class="font-weight-bold">
                    {{ network.network.label }}
                  </h4>
                  <h4 class="font-weight-medium">
                    {{ network.followers }} {{ $t('followers') }}
                  </h4>
                  <span
                    class="text-xs text-no-wrap">{{
                      network.status ? $t('Communauté active') : $t('Communauté inactive')
                    }}</span>
                </div>

                <v-spacer></v-spacer>

                <div class="ms-1" style="width: 100px; max-width: 100px">
                  <small class="text--primary font-weight-medium mb-1">
                    {{ network.followers }} followers
                  </small>
                  <v-progress-linear
                    :value="getProgressValue(network.followers)"
                    :color="network.network.color"
                    striped
                    rounded
                  ></v-progress-linear>
                </div>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card outlined>
          <v-card-title class="text-subtitle-1 font-weight-bold py-2">
            <span>{{ $t('Prix littéraires') }}</span>
          </v-card-title>

          <v-card-text style="max-height: 450px" class="overflow-y-auto">
            <p v-if="!(author.awards || []).length">{{ $t('Aucun prix littéraire renseigné') }}</p>
            <v-timeline
              dense
              class="timeline-custom-dense timeline-custom-dots"
            >
              <v-timeline-item
                v-for="(ev,index) in author.awards"
                :key="ev.id"
                small
                :color="`${index%2?'primary':'info'}`"
              >
                <div class="d-flex justify-space-between align-center flex-wrap">
                  <h4 class="font-weight-semibold me-1">
                    {{ ev.name }} {{ ev.category_label ? `(${ev.category_label})` : '' }}
                  </h4>
                </div>
                <small class="text-no-wrap font-weight-medium">{{ ev.year }}</small>
                <p class="my-1">
                  {{ ev.category }}
                </p>
                <p class="my-1" v-if="ev.genre">
                  Genre : {{ ev.genre ? ev.genre.label : '' }}
                </p>
                <p class="my-1" v-if="ev.publication">
                  Dossier : {{ ev.publication_id }} - {{
                    ev.publication ? ev.publication.title : ''
                  }}
                </p>
                <!--                <v-btn outlined x-small color="info" :href="ev.location" target="_blank" class="mt-2" v-if="ev.location">
                                  <v-icon
                                    class="me-1"
                                  >
                                    {{ mdiLink }}
                                  </v-icon>
                                  <span class="">
                                    {{ $t("Voir") }}
                                  </span>
                                </v-btn>-->
              </v-timeline-item>
            </v-timeline>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" md="4" sm="6">
        <v-card outlined style="max-height: 250px" class="overflow-y-auto">
          <v-card-title class="text-subtitle-1 font-weight-bold py-2">
            {{ $t('Participations à des salons') }}
          </v-card-title>

          <v-card-text style="max-height: 450px" class="overflow-y-auto">
            <p v-if="!(author.author_salons || []).length">
              {{ $t('Aucune participation à un salon renseignée') }}</p>
            <v-timeline
              dense
              class="timeline-custom-dense timeline-custom-dots"
            >
              <v-timeline-item
                v-for="(ev,index) in author.author_salons"
                :key="ev.id"
                small
                :color="`${index%2?'primary':'info'}`"
              >
                <div class="d-flex justify-space-between align-center flex-wrap">
                  <h4 class="font-weight-semibold me-1">
                    {{ ev.label }}
                  </h4>
                </div>
                <small class="text-no-wrap font-weight-medium">{{ formatDate(ev.date) }}</small>
                <p class="my-1">
                  {{ ev.location }}
                </p>
                <!--                <v-btn outlined x-small color="info" :href="ev.location" target="_blank" class="mt-2" v-if="ev.location">
                                  <v-icon
                                    class="me-1"
                                  >
                                    {{ mdiLink }}
                                  </v-icon>
                                  <span class="">
                                    {{ $t("Voir") }}
                                  </span>
                                </v-btn>-->
              </v-timeline-item>
            </v-timeline>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" md="4" sm="6">
        <v-card outlined style="max-height: 250px" class="overflow-y-auto">
          <v-card-title class="text-subtitle-1 font-weight-bold py-2">
            {{ $t('Séances de dédicaces') }}
          </v-card-title>
          <v-card-text style="max-height: 450px" class="overflow-y-auto">
            <p v-if="!(author.author_sessions || []).length">
              {{ $t('Aucune séance de dédicace renseignée') }}</p>
            <v-timeline
              dense
              class="timeline-custom-dense timeline-custom-dots"
            >
              <v-timeline-item
                v-for="(ev,index) in author.author_sessions"
                :key="ev.id"
                small
                :color="`${index%2?'primary':'info'}`"
              >
                <div class="d-flex justify-space-between align-center flex-wrap">
                  <h4 class="font-weight-semibold me-1">
                    {{ ev.label }}
                  </h4>
                </div>
                <small class="text-no-wrap font-weight-medium">{{ formatDate(ev.date) }}</small>
                <p class="my-1">
                  {{ ev.location }}
                </p>
                <!--                <v-btn outlined x-small color="info" :href="ev.location" target="_blank" class="mt-2" v-if="ev.location">
                                  <v-icon
                                    class="me-1"
                                  >
                                    {{ mdiLink }}
                                  </v-icon>
                                  <span class="">
                                    {{ $t("Voir") }}
                                  </span>
                                </v-btn>-->
              </v-timeline-item>
            </v-timeline>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" md="4" sm="6">
        <v-card outlined style="max-height: 250px" class="overflow-y-auto">
          <v-card-title class="text-subtitle-1 font-weight-bold py-2">
            {{ $t('Publications dans les médias') }}
          </v-card-title>
          <v-card-text style="max-height: 450px" class="overflow-y-auto">
            <p v-if="!(author.author_media_publications || []).length">
              {{ $t('Aucune publication dans les médias renseignée') }}</p>
            <v-timeline
              dense
              class="timeline-custom-dense timeline-custom-dots"
            >
              <v-timeline-item
                v-for="(ev,index) in author.author_media_publications"
                :key="ev.id"
                small
                :color="`${index%2?'primary':'info'}`"
              >
                <h5 v-if="ev.media" class="font-weight-semibold me-1">
                  {{ ev.media }}
                </h5>
                <div class="d-flex justify-space-between align-center flex-wrap">
                  <h4 class="font-weight-semibold me-1">
                    {{ ev.media_type ? ev.media_type.label : '' }}
                  </h4>
                </div>

                <small class="text-no-wrap font-weight-medium">{{ formatDate(ev.date) }}</small>
                <p class="mb-0">
                  {{ ev.location }}
                </p>
                <v-btn outlined x-small :color="`${index%2?'primary':'info'}`" :href="ev.link"
                       target="_blank" class="mt-2" v-if="ev.link">
                  <v-icon
                    class="me-1"
                  >
                    {{ mdiLink }}
                  </v-icon>
                  <span class="">
                    {{ $t('Voir') }}
                  </span>
                </v-btn>
              </v-timeline-item>
            </v-timeline>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- 4. QUESTIONNAIRE -->
      <v-col cols="12">
        <AuthorQuestionnaireOverview :author="author"/>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {mdiEmailSendOutline, mdiFileDocumentEditOutline, mdiLink} from '@mdi/js'
import {formatDate} from '@core/utils/filter'
import AuthorQuestionnaireOverview
  from '@/views/apps/author/author-view/components/AuthorQuestionnaireOverview.vue'
import store from "@/store";

export default {
  name: 'AuthorOverview',
  components: {
    AuthorQuestionnaireOverview,
  },
  props: {
    author: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    loadingDate: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const icons = {
      mdiEmailSendOutline,
      mdiFileDocumentEditOutline,
      mdiLink,
    }

    const formatDateLocal = date => formatDate(date)

    const formatPhoneNumber = val => {
      if (val.country_id == (store.state.app.settings.default_country_id || 79)) {
        // let p = val.phone
        // var string = "02076861111"
        let string = val.phone
        if ((!string || !string.trim().length) && val.addresses) {
          return val.addresses.map(a => formatPhoneNumber(a)).join(', ')
        }
        if (string && string.length < 9) {
          string = `0${string}`
        }

        if (string) {
          if (string.length > 7 && string.length < 10) {
            const phone = string.replace(/(\d{2})(\d{2})(\d{2})(\d{2})/, '$1.$2.$3.$4')

            return phone
          }
          if (string.length > 9) {
            const phone = string.replace(/(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/, '$1.$2.$3.$4.$5')

            return phone
          }

          const phone = string.replace(/(\d{2})(\d{2})(\d{7})/, '$1.$2.$3')

          return phone
        }

        return val.phone
      }

      return val.phone
    }
    const getAuthorColor = () => 'primary'


    const getColor1 = () => {
      const progress = props.author?.progress
      if (!progress) return 'error'
      if (progress < 25) return 'error'
      if (progress <= 75) return 'warning'

      return 'success'
    }

    const getProgressValue = followers => Math.min(followers || 0, 100)

    return {
      icons,
      formatDate: formatDateLocal,
      formatPhoneNumber,
      getAuthorColor,

      getProgressValue,
      getColor1,
    }
  },
}
</script>
